import { Component, Input } from '@angular/core';
import { AdvisorData } from '../advisor.model';

@Component({
    selector: 'ifb-advisor-info-widget',
    templateUrl: './advisor-info-widget.component.html',
    styleUrls: ['./advisor-info-widget.component.scss'],
    standalone: false
})
export class AdvisorInfoWidgetComponent {
  @Input()
  data: AdvisorData;
}
